import { CampaignContact, CampaignPageActions, CampaignTypes } from "../../App/Enums/CampaignTypes";

const defaultContactPreference = {
  [CampaignTypes.Form]: CampaignContact.Phone,
  [CampaignTypes.JobAlerts]: CampaignContact.Email,
  [CampaignTypes.JobAlertsAndTalentNetwork]: CampaignContact.EmailAndPhone,
  [CampaignTypes.TalentNetwork]: CampaignContact.Phone,
  [CampaignTypes.Event]: CampaignContact.Phone,
};

const talentNetworkCampaignTypes = [
  CampaignTypes.JobAlerts,
  CampaignTypes.JobAlertsAndTalentNetwork,
  CampaignTypes.TalentNetwork,
] as const;

const talentNetworkCampaignTypeLabels = {
  [CampaignTypes.JobAlerts]: "Job Alerts",
  [CampaignTypes.JobAlertsAndTalentNetwork]: "Job Alerts & Talent Network",
  [CampaignTypes.TalentNetwork]: "Talent Network",
};

const campaignTypeHelperText = {
  [CampaignTypes.Form]: "A targeted marketing effort aimed at a specific group of candidates.",
  [CampaignTypes.JobAlerts]:
    "Enable your candidates to join an automated email list which will send them alerts whenever you post new jobs that match their Area of Interest or Location preferences.",
  [CampaignTypes.JobAlertsAndTalentNetwork]:
    "A combination of the Talent Network and Job Alerts Campaigns that allows your candidates to first identify their interests and then opt-in to additional communications with your recruiters so you can engage them on an ongoing basis.",
  [CampaignTypes.TalentNetwork]:
    "Target a pool of potential candidates who have expressed interest in your company.",
  [CampaignTypes.Event]: "A targeted marketing effort aimed at a specific event or group of events.",
};

const subtitleMessageTable = {
  [CampaignPageActions.Create]: "To create a Form, enter a name and configure your settings",
  [CampaignPageActions.Edit]: "To edit this Form, update the name and settings",
  [CampaignPageActions.Duplicate]: "Create a new Form by duplicating an existing one",
};

const submitButtonLoadingTable = {
  [CampaignPageActions.Create]: "Creating Form...",
  [CampaignPageActions.Edit]: "Saving Form...",
  [CampaignPageActions.Duplicate]: "Duplicating Form...",
};

function getSubtitleMessage(action: CampaignPageActions, isTalentNetwork: boolean) {
  if (isTalentNetwork && action === CampaignPageActions.Edit) {
    return "Adjust your Talent Network form to best fit your strategy by revising the form settings.";
  }
  return subtitleMessageTable[action];
}

function getSubmitButtonLoadingText(action: CampaignPageActions, isTalentNetwork: boolean) {
  if (isTalentNetwork && action === CampaignPageActions.Edit) {
    return "Saving Talent Network...";
  }
  return submitButtonLoadingTable[action];
}

const getDefaultContactPreference = (campaignType: CampaignTypes, contactType: CampaignContact) => {
  let preference = contactType ? contactType : defaultContactPreference[campaignType];
  if (campaignType === CampaignTypes.JobAlertsAndTalentNetwork && preference === CampaignContact.Phone) {
    preference = CampaignContact.EmailAndPhone;
  }
  if (campaignType === CampaignTypes.JobAlerts) {
    preference = CampaignContact.Email;
  }
  return preference;
};

const getWelcomeMessageDisplay = (welcomeMessage: string) => {
  return welcomeMessage
    ? welcomeMessage.length <= 150
      ? `"${welcomeMessage}"`
      : `"${welcomeMessage.substring(0, 150)}..."`
    : "---";
};

const getWelcomeMessageSubjectDisplay = (welcomeMessageSubject: string | null | undefined) => {
  return welcomeMessageSubject ? `"${welcomeMessageSubject}"` : "---";
};

export {
  talentNetworkCampaignTypes,
  talentNetworkCampaignTypeLabels,
  campaignTypeHelperText,
  getSubtitleMessage,
  getDefaultContactPreference,
  getWelcomeMessageDisplay,
  getWelcomeMessageSubjectDisplay,
  getSubmitButtonLoadingText,
};
